export type RegistrationMenuStatus = "登録済み" | "未登録";
export type RegistrationStatusTone = "muted" | "accent";

interface BankAccountSource {
  bank?: string | null;
  bank_branch?: string | null;
  bank_branch_number?: string | null;
  account_type?: string | null;
  account_number?: string | null;
  account_holder?: string | null;
}

interface PersonalInformationSource {
  full_name?: string | null;
  date_of_birth?: string | null;
  phone_number?: string | null;
  invoice_registration_number?: string | null;
  billing_postal_code?: string | null;
  billing_prefecture?: string | null;
  billing_address_line1?: string | null;
  billing_address_line2?: string | null;
  is_shipping_same_as_billing?: boolean | null;
  shipping_postal_code?: string | null;
  shipping_prefecture?: string | null;
  shipping_address_line1?: string | null;
  shipping_address_line2?: string | null;
}

const BANK_ACCOUNT_MENU_FIELDS = [
  "bank",
  "bank_branch",
  "account_type",
  "account_number",
  "account_holder",
] as const satisfies readonly (keyof BankAccountSource)[];

const isFilled = (value: unknown): boolean =>
  typeof value === "string" ? value.trim().length > 0 : value != null && value !== "";

export const isBankAccountRegistered = (
  user: BankAccountSource | null | undefined,
): boolean => {
  if (!user) return false;
  return BANK_ACCOUNT_MENU_FIELDS.every((field) => isFilled(user[field]));
};

export const isPersonalInformationRegistered = (
  user: PersonalInformationSource | null | undefined,
): boolean => {
  if (!user) return false;

  const requiredFields: (keyof PersonalInformationSource)[] = [
    "full_name",
    "phone_number",
    "billing_postal_code",
    "billing_prefecture",
    "billing_address_line1",
  ];

  if (!requiredFields.every((field) => isFilled(user[field]))) {
    return false;
  }

  if (user.is_shipping_same_as_billing === false) {
    const shippingFields: (keyof PersonalInformationSource)[] = [
      "shipping_postal_code",
      "shipping_prefecture",
      "shipping_address_line1",
    ];
    return shippingFields.every((field) => isFilled(user[field]));
  }

  return true;
};

export const getRegistrationMenuStatus = (
  isComplete: boolean,
): RegistrationMenuStatus => (isComplete ? "登録済み" : "未登録");

export const getRegistrationStatusTone = (
  isComplete: boolean,
): RegistrationStatusTone => (isComplete ? "muted" : "accent");
